import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";

export const buildEmployeeAssigneeOption = (emp) => {
    const name =
        `${emp.FirstName || emp.firstName || ""} ${emp.LastName || emp.lastName || ""}`.trim() ||
        emp.email ||
        emp.Email ||
        `Employee ${emp.userId || emp.id}`;

    const department =
        emp.department?.name ||
        emp.departmentName ||
        emp.department_name ||
        "";

    return {
        value: String(emp.userId || emp.id),
        name,
        label: name,
        email: emp.email || emp.Email || "",
        department,
    };
};

export const buildEmployeeAssigneeOptionFromAssignee = (assignee, id) => {
    const name =
        assignee?.name ||
        `${assignee?.FirstName || assignee?.firstName || ""} ${assignee?.LastName || assignee?.lastName || ""}`.trim() ||
        `User ${id}`;

    const department =
        assignee?.department?.name ||
        assignee?.departmentName ||
        assignee?.department_name ||
        "";

    return {
        value: String(id),
        name,
        label: name,
        email: assignee?.email || "",
        department,
    };
};

export const EmployeeAssigneeOption = ({ option }) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            width: "100%",
            py: 0.25,
            minWidth: 0,
        }}
    >
        <Stack spacing={0.25} sx={{ minWidth: 0, flex: 1 }}>
            <Typography
                variant="body2"
                fontWeight={600}
                fontSize="12px"
                color="#1e293b"
                noWrap
            >
                {option.name}
            </Typography>
            {option.email && (
                <Typography variant="caption" color="#6b7280" fontSize="11px" lineHeight={1.3} noWrap>
                    {option.email}
                </Typography>
            )}
        </Stack>
        {option.department && (
            <Box
                component="span"
                sx={{
                    px: 1.25,
                    py: 0.25,
                    borderRadius: "999px",
                    bgcolor: "#f1f5f9",
                    color: "#475569",
                    fontSize: "11px",
                    fontWeight: 500,
                    lineHeight: 1.4,
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                    ml: "auto",
                }}
            >
                {option.department}
            </Box>
        )}
    </Box>
);

export const renderEmployeeAssigneeOption = (props, option) => (
    <li {...props} key={option.value}>
        <EmployeeAssigneeOption option={option} />
    </li>
);

export const filterEmployeeAssigneeOptions = createFilterOptions({
    limit: 100,
    stringify: (option) =>
        `${option?.name || ""} ${option?.email || ""} ${option?.department || ""}`.trim(),
});
